import {
    Button,
    CircularProgress,
    Tooltip,
    tooltipClasses,
    TextField,
    InputAdornment,
    Divider,
    Radio,
    RadioGroup,
    FormControlLabel,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Save, BorderColor, Payments, Info } from "@mui/icons-material";
import usePlatformFeesPayable from "../hooks/usePlatformFeesPayable";
import useEvent from "../../../../../../hooks/event-hooks/useEvent";
import { H4, Body3, H5, Body2, Body1 } from "../../../../../../themes/typography";

const CustomWidthTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
))({
    [`& .${tooltipClasses.tooltip}`]: {
        maxWidth: 400,
        padding: "12px 14px",
        backgroundColor: "var(--primary-color)",
        borderRadius: "1rem",
        border: '1px solid var(--divider-color)',
        boxShadow: '0 0 10px var(--gradient-overlay-bg-color)',
    },
});

function PlatformFeesPayable() {

    const {
        handleSubmit,
        feesRule,
        loading,
        // isEditable,
        // setIsEditable,
        value,
        setValue,
        setPassPlatform,
        price,
        setPrice,
        qty,
        setQty,
        inr,
        res
    } = usePlatformFeesPayable();

    const { isPaidTicketCreated, isCommissionPaidByEndUser} = useEvent();

    const tooltipContent = (
        <div className="fees-rule-tooltip-container">
            <Body3 fontWeight={600} color="var(--quaternary-color)">
                Fee Rules
            </Body3>

            {feesRule.map((fee, index) => (
                <div key={index} className="fees-rule-tooltip-sub-container">
                    <Body3 fontWeight={500} color="var(--quaternary-color)">
                        {fee.title}
                    </Body3>

                    <ul className="fees-rule-list-point">
                        {fee.rules.map((rule, index) => (
                            <Body3 key={index} fontWeight={300} color="var(--quaternary-color)">
                                <li>{rule}</li>
                            </Body3>
                        ))}
                    </ul>
                </div>
            ))}

        </div>
    );


    return (
        <div className="invoice-info-main-container">
            <div id="personal-info-form">
                <div className="invoice-info-header">
                    <div className="invoice-info-title">
                        <span className="invoice-info-icon">
                            <Payments color="secondary" sx={{ fontSize: '1.75rem' }} />
                        </span>

                        <H4 fontWeight={600}>
                            Platform Fees Settings
                        </H4>

                        <CustomWidthTooltip title={tooltipContent} placement="top-start">
                            <Info color="white" />
                        </CustomWidthTooltip>
                    </div>

                    {(isCommissionPaidByEndUser === 0 && isPaidTicketCreated)  && (
                        <div className="invoice-info-edit-button">
                            <Button
                                variant="text"
                                type="button"
                                // startIcon={
                                //     loading && isEditable ? (
                                //         <CircularProgress size={20} color="inherit" />
                                //     ) : isEditable ? (
                                //         <Save />
                                //     ) : (
                                //         <BorderColor />
                                //     )
                                // }
                                startIcon={
                                    loading ? (
                                        <CircularProgress size={20} color="inherit" />
                                    ) : (
                                        <Save />
                                    )
                                }
                                disabled={loading || value === null}
                                disableRipple
                                // onClick={() => {
                                //     if (isEditable) {
                                //         handleSubmit();
                                //     } else {
                                //         setIsEditable(true);
                                //     }
                                // }}
                                onClick={handleSubmit}
                            >
                                {/* {isEditable ? (loading ? 'Saving' : 'Save') : 'Edit'} */}
                                {loading ? 'Saving' : 'Save'}
                            </Button>
                        </div>
                    )}

                </div>
                <div className="fees-btn-with-calc">
                    <div className="invoice-info-details">
                        <div className="platfform-fees-radio-buttons">
                            <div className="radio-btns-title">
                                <H5>
                                    Platform fees payable by
                                </H5>
                            </div>
                            <div className="platfform-fees-radio-buttons">
                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    value={value}
                                    onChange={(e) => {
                                        const newValue = e.target.value === 'true';
                                        setValue(newValue);
                                        setPassPlatform(newValue);
                                    }}
                                >
                                    <FormControlLabel
                                        value={false}
                                        control={<Radio />}
                                        label={(
                                            <Body1>
                                                Event Creator (Me)
                                            </Body1>
                                        )}
                                    />
                                    <FormControlLabel
                                        value={true}
                                        control={<Radio />}
                                        label={(<Body1>
                                            Pass platform fee to buyer
                                        </Body1>)}
                                    />
                                </RadioGroup>
                            </div>
                        </div>
                    </div>

                    <div className="commission-calculator-container">

                        <div className="fees-calculator">

                            <div className="fees-calculator-title">
                                <H5 fontWeight={700} color="var(--secondary-color)">
                                    Interactive calculator
                                </H5>
                                <Body3>
                                    Model buyer vs. creator scenarios and totals per quantity
                                </Body3>
                            </div>

                            <div className="fees-calculator-inputs">
                                <TextField
                                    label="Ticket Price"
                                    type="number"
                                    helperText="Set to 0 for free tickets."
                                    value={Number.isFinite(price) ? price : 0}
                                    onChange={(e) => setPrice(Number.parseFloat(e.target.value || "0"))}
                                    // sx={{
                                    //     '& .MuiOutlinedInput-root': { maxWidth: '160px' },
                                    // }}
                                    fullWidth
                                    slotProps={{
                                        input: {
                                            startAdornment: (
                                                <InputAdornment
                                                    position="start"
                                                >
                                                    ₹
                                                </InputAdornment>
                                            ),
                                            inputProps: {
                                                inputMode: 'numeric',
                                                pattern: '[0-9]*',
                                                min: 0
                                            }
                                        },
                                    }}
                                />

                                <TextField
                                    label="Quantity"
                                    type="number"
                                    value={Number.isFinite(qty) ? qty : 0}
                                    onChange={(e) => setQty(Number.parseInt(e.target.value || "0", 10))}
                                    defaultValue={1}
                                    // sx={{
                                    //     '& .MuiOutlinedInput-root': { maxWidth: '160px' },
                                    // }}
                                    fullWidth
                                    slotProps={{
                                        input: {
                                            inputProps: {
                                                inputMode: 'numeric',
                                                pattern: '[0-9]*',
                                                min: 0
                                            }
                                        },
                                    }}
                                />
                            </div>

                            <div className="calculator-result-container">

                                <div className="per-ticket-fees-container">
                                    <div className="per-ticket-fee-title">
                                        <Body2>
                                            Per ticket
                                        </Body2>
                                    </div>

                                    <div className="per-ticket-fee-details">

                                        <div className="per-ticket-fee-amount">

                                            <div className="per-ticket-fees">
                                                <div className="fees-label">
                                                    <Body3>
                                                        Booking Fee
                                                    </Body3>
                                                </div>
                                                <div className="fees-amount">
                                                    <Body3 fontWeight={500}>
                                                        {inr(res.bookingFeePer)}
                                                    </Body3>
                                                </div>
                                            </div>

                                            <div className="per-ticket-fees">
                                                <div className="fees-label">
                                                    <Body3>
                                                        Platform Fee
                                                    </Body3>
                                                </div>
                                                <div className="fees-amount">
                                                    <Body3 fontWeight={500}>
                                                        {inr(res.platformFeePer)}
                                                    </Body3>
                                                </div>
                                            </div>
                                        </div>

                                        <Divider
                                            sx={{
                                                borderColor: 'var(--divider-color)',
                                                alignSelf: 'stretch',
                                            }}
                                        />

                                        <div className="per-ticket-fee-amount">

                                            <div className="per-ticket-fees">
                                                <div className="fees-label">
                                                    <Body3>
                                                        Buyer Pays
                                                    </Body3>
                                                </div>
                                                <div className="fees-amount">
                                                    <Body3 fontWeight={500}>
                                                        {inr(res.buyerPaysPer)}
                                                    </Body3>
                                                </div>
                                            </div>

                                            <div className="per-ticket-fees">
                                                <div className="fees-label">
                                                    <Body3>
                                                        Creator Receives
                                                    </Body3>
                                                </div>
                                                <div className="fees-amount">
                                                    <Body3 fontWeight={500}>
                                                        {inr(res.creatorReceivesPer)}
                                                    </Body3>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="total-fees-container">

                                    <div className="per-ticket-fee-title">
                                        <Body2>
                                            Totals (× {qty || 0})
                                        </Body2>
                                    </div>

                                    <div className="buyer-creator-pays-container">

                                        <div className="buyer-creator-pays">
                                            <Body3>
                                                Buyer Pays Total
                                            </Body3>

                                            <div className="buyer-creator-pays-amount">
                                                <H5 color="var(--secondary-color)" fontWeight={600}>
                                                    {inr(res.buyerPaysTotal)}
                                                </H5>
                                            </div>
                                        </div>
                                        <div className="buyer-creator-pays">
                                            <Body3>
                                                Creator Receives Total
                                            </Body3>

                                            <div className="buyer-creator-pays-amount">
                                                <H5 color="var(--secondary-color)" fontWeight={600}>
                                                    {inr(res.creatorReceivesTotal)}
                                                </H5>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            <div className="fees-calculator">
                                <Body3>
                                    All fees exclude GST. No extra payment gateway fees are charged by the platform.
                                </Body3>
                            </div>

                        </div>

                    </div>

                </div>
            </div>
        </div>
    )
}

export default PlatformFeesPayable